<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center">
      <questions title="Introdução" :items='questions' :key-form='keyForm'
        prev="/" next="/pessoas" />
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import Questions from './Questions';

/* eslint-disable max-len */
export default {
  name: 'intro-form',
  components: { Icon, Questions },
  data() {
    return {
      keyForm: 'understanding',
      questions: [
        { field: 'td_understanding', value: 0, title: 'Eu tenho pleno entendimento da transformação digital e sei que ela vai impactar minha carreira, meu trabalho e as empresas onde trabalharei.' },
        { field: 'td_understanding_corp', value: 0, title: 'Minha empresa tem pleno entendimento da transformação digital e sabe que ela impacta e vai impactar ainda mais nosso modelo de negócios.' },
        { field: 'td_readiness', value: 0, title: 'Minha empresa já está preparada ou está se preparando para as diversas mudanças que ocorrerão digitalmente nos próximos anos.' },
        { field: 'td_investment', value: 0, title: 'Minha empresa está investindo o suficiente em estratégias digitais para se adequar às mudanças do mercado e se preparar para as próximas.' },
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 1);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/IntroForm.vue